/**
 * @file useShopToday.ts
 * @description «Сейчас» для групп страницы «Задачи» (phase19.31, SC60):
 * момент отсчёта и его календарный день по поясу магазина.
 *
 * Вкладку оставили открытой на ночь — после возврата (фокус окна или
 * вкладка снова видна) день сменился, и «Завтра» должно стать «Сегодня».
 * Момент обновляется, только если сменился день в поясе магазина: группы
 * не пересчитываются на каждое переключение окна.
 */

import { useEffect, useState } from "react";

import { dayKeyInZone } from "./task-groups";

export interface ShopToday {
  /** Момент отсчёта групп, мс. */
  now: number;
  /** День «гггг-мм-дд» по поясу магазина. */
  dayKey: string;
}

export function useShopToday(timeZone: string): ShopToday {
  const [today, setToday] = useState<ShopToday>(() => {
    const now = Date.now();
    return { now, dayKey: dayKeyInZone(now, timeZone) };
  });

  useEffect(() => {
    const check = () => {
      if (document.visibilityState !== "visible") return;
      const now = Date.now();
      const dayKey = dayKeyInZone(now, timeZone);
      setToday((prev) => (prev.dayKey === dayKey ? prev : { now, dayKey }));
    };
    check();
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", check);
    return () => {
      window.removeEventListener("focus", check);
      document.removeEventListener("visibilitychange", check);
    };
  }, [timeZone]);

  return today;
}
